import request from '@/utils/request'

//大屏数据
export function getScreenData() {
    return request({
        url: '/api/large_screen_data_one',
        method: 'post'
    })
}
//大屏 echarts数据
export function getEchartsData() {
    return request({
        url: '/api/large_screen_data_two',
        method: 'post'
    })
}